import apiClient from "../../../components/api/apiClient";

 
/**
 * Resolves the base URL for an API call.
 * If connectionName is 'backend', it returns the versioned /api endpoint.
 * Otherwise, it looks for the environment variable mapping.
 */
function resolveBaseUrl(connectionName?: string): string {
  if (!connectionName) {
    return process.env.REACT_APP_API_BASE_URL || '';
  }

  const envKey = `REACT_APP_API_URL_${connectionName}`;
  const baseUrl = (process.env as Record<string, string | undefined>)[envKey];

  if (!baseUrl) {
    console.warn(`⚠️ Missing environment variable: ${envKey}`);
  }

  return baseUrl+"api/" || process.env.REACT_APP_API_BASE_URL || '';
}

export const apiService = {
  get: async (url: string, params = {}, connectionName?: string) => {
    const baseURL = resolveBaseUrl(connectionName);
    const response = await apiClient.get(url, { params, baseURL });
    return response.data;
  },


  post: async (url: string, data: any, connectionName?: string) => {
    const baseURL = resolveBaseUrl(connectionName);
    const response = await apiClient.post(url, data, { baseURL });
    return response.data;
  },

  put: async (url: string, data: any, connectionName?: string) => {
    const baseURL = resolveBaseUrl(connectionName);
    const response = await apiClient.put(url, data, { baseURL });
    return response.data;
  },

  delete: async (url: string, connectionName?: string) => {
    const baseURL = resolveBaseUrl(connectionName);
    const response = await apiClient.delete(url, { baseURL });
    return response.data;
  },

  postFormData: async (url: string, data: any, connectionName?: string) => {
    const baseURL = resolveBaseUrl(connectionName);
    const config = {
      headers: { 'Content-Type': 'multipart/form-data' },
      baseURL,
    };
    const response = await apiClient.post(url, data, config);
    return response.data;
  },

  postForm: async (url: string, formData: FormData, connectionName: string) => {
    const baseURL = resolveBaseUrl(connectionName);
    const response = await fetch(`${baseURL}${url}`, {
      method: 'POST',
      body: formData,
      headers: {
        // DO NOT manually set 'Content-Type' — browser will set correct boundaries
        Authorization: `Bearer ${localStorage.getItem('token') ?? ''}`
      }
    });

    if (!response.ok) {
      throw new Error(`Upload failed: ${response.statusText}`);
    }

    return await response.json();
  },
  getBlob: async (url: string, connectionName?: string) => {
    const baseURL = resolveBaseUrl('backend');
    const response = await apiClient.get(url, {
      baseURL,
      responseType: 'blob'
    });
    return response.data;
  }

};
